var __webpack_exports__ = {};
/*!***********************************!*\
  !*** ./src/scripts/fostr-cart.js ***!
  \***********************************/
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.dataset.connectedItem) {
        const item = this.closest('cart-items').querySelector(`[data-product-connection="${this.dataset.connectedItem}"]`).dataset.removeKey
        this.closest('cart-items').removeItems([item,this.dataset.key], false);
      } else {
        this.closest('cart-items').updateQuantity(this.dataset.index, 0, undefined, false);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.miniCart = document.getElementById('mini-cart');
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    // Note: MAX 5 sections (or AJAX API requests will fail)
    let footerSection, bodySection;
    const sections = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];

    if (document.getElementById('fostr-mini-cart-footer')) {
      sections.push({
        id: 'fostr-mini-cart-footer',
        section: document.getElementById('fostr-mini-cart-footer').dataset.id,
        selector: '.js-contents'
      });
    }

    if (document.getElementById('fostr-main-cart-items')) {
      sections.push({
        id: 'fostr-main-cart-items',
        section: document.getElementById('fostr-main-cart-items').dataset.id,
        selector: '.js-contents',
      });
    } else if (document.getElementById('fostr-mini-cart-items')) {
      sections.push({
        id: 'fostr-mini-cart-items',
        section: document.getElementById('fostr-mini-cart-items').dataset.id,
        selector: '.js-contents'
      });
    }

    return sections;
  }

  renderContents(parsedState, animateInClass) {
    if (!parsedState.sections) {
      return;
    }

    this.getSectionsToRender().forEach(section => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

      if (!elementToReplace) {
        return;
      }

      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector, animateInClass);

      elementToReplace.querySelectorAll('.hide-to-animate').forEach(el => {
        el.classList.add('animate__animated', 'animate__fadeIn');
        el.addEventListener('animationend', () => {
          el.classList.remove('animate__animated', 'animate__fadeIn');
        }, { once: true });
        window.requestAnimationFrame(() => el.classList.remove('hide-to-animate'));
      });
    });

    this.updateEmptyState(parsedState);
    this.miniCart?.open();
    this.updateUpsells();
  }

  getSectionInnerHTML(html, selector = '.shopify-section', hideClass) {
    let newEl = new DOMParser().parseFromString(html, 'text/html');
    newEl = newEl.querySelector(selector) || newEl;
    if (hideClass) {
      newEl.querySelectorAll(hideClass).forEach(el => el.classList.add('hide-to-animate'));
    }
    return newEl.innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    if (!line) {
      return;
    }
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    } else {
      const quantityInput = document.getElementById(`CartItem-${line}`)?.querySelector('quantity-input');
      if (quantityInput.dataset.connectedItem) {
        const container = quantityInput.closest('cart-items');
        const item = container
          .querySelector(`[data-product-connection="${quantityInput.dataset.connectedItem}"]`)
          .closest('.cart-item')

        const quantity = quantityInput.querySelector('input').value

        if (quantity !== item.querySelector('quantity-input input').value ) {
          this.closest('cart-items').updateQuantity(item.dataset.index, quantity);
        }
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  enableLoading(line) {
    document.querySelector('#fostr-main-cart-items, #fostr-mini-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll('.loading-overlay')[line - 1]?.classList.remove('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
    document.getElementById('checkout').disabled = true;
  }

  disableLoading() {
    document.getElementById('checkout').removeAttribute('disabled')
    document.querySelector('#fostr-main-cart-items, #fostr-mini-cart-items').classList.remove('cart__items--disabled');
  }

  updateUpsells() {
    const upsells = document.querySelector('cart-upsells');
    if (upsells && upsells.update) {
      return upsells.update();
    } else {
      return Promise.resolve(false);
    }
  }

  updateEmptyState(parsedState) {
    const empty = parsedState.item_count === 0;
    this.classList.toggle('is-empty', empty);
    document.querySelector('#main-cart-footer, #fostr-mini-cart-footer')?.classList.toggle('is-empty', empty);
  }

  updateQuantity(line, quantity, fieldName, skipGiftsCheck) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    return fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        this.renderContents(parsedState);
        if (parsedState.item_count > 0 && quantity > 0) {
          this.updateLiveRegions(line, parsedState.item_count);
        }
        document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${fieldName}"]`)?.focus();
        this.disableLoading();
        if (skipGiftsCheck) {
          return parsedState;
        }
        return this.checkGifts();
      }).catch(err => {
        console.error(err);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  removeItems(variant_ids, skipGiftsCheck) {
    document.getElementById('checkout').disabled = true;
    const updatesObj = variant_ids.reduce(
      (sum, val) => {
        if (isNaN(val)) {
          if (val.includes(':')) {
            sum[val] = 0;
          }
        } else {
          sum[parseInt(val)] = 0;
        }
        return sum;
      }, {}
    );

    const body = JSON.stringify({
      updates: updatesObj,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    return fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((parsedState) => {
        this.renderContents(parsedState);
        this.disableLoading();
        if (skipGiftsCheck) {
          return parsedState;
        }
        return this.checkGifts();
      })
      .catch(err => {
        this.querySelectorAll('.loading-overlay').forEach(overlay => overlay.classList.add('hidden'));
        console.error(err);
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  addItem(variant_id, quant = 1, props = {}) {
    if (!variant_id) {
      console.error('variant_id is required')
      return Promise.resolve(false);
    }

    let itemsArr;

    // allows passing items object as a single param instead of a variant_id
    // for adding multiple products
    if (variant_id?.length) {
      itemsArr = variant_id;
    } else {
      itemsArr = [{
        quantity: quant,
        id: variant_id,
        properties: props
      }];
    }

    const body = JSON.stringify({
      items: itemsArr,
      sections: this.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    });

    return fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(parsedState => {
        this.renderContents(parsedState);
        this.disableLoading();
        return parsedState;
      })
      .catch(err => {
        this.querySelectorAll('.loading-overlay').forEach(overlay => overlay.classList.add('hidden'));
        console.error(err);
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  async checkGifts() {
    return await fetch('/cart.js')
      .then(response => response.json())
      .then(parsedState => this.checkFreeSamples(parsedState))
      .then(parsedState => this.checkFreeGift(parsedState))
      .then(parsedState => this.checkAttachedGifts(parsedState))
      .then(document.getElementById('checkout').removeAttribute('disabled'))
  }

  checkFreeGift(parsedState) {
    if (!window.freeGiftData?.thresholds) {
      return;
    }
    const gifts = window.freeGiftData.thresholds.sort((a, b) => a.threshold - b.threshold);
    const cartStringified = JSON.stringify(parsedState.items);
    const giftInCart = cartStringified.includes('_giftId');
    const freeGiftThreshold = gifts[0].threshold;

    let realTotalPrice = parsedState.total_price;

    const giftIndex = parsedState.items.some(i => i.properties !== null && i.properties['_giftId']) ? parsedState.items.findIndex(i => i.properties['_giftId']) : -1;

    if (giftIndex !== -1) {
      realTotalPrice = realTotalPrice - parsedState.items[giftIndex].final_price;
    }

    const giftEligible = (realTotalPrice >= freeGiftThreshold);
    const giftVarId = window.freeGiftData.thresholds[0].variant_id;
    const giftProps = { '_giftId': Math.floor((Math.random() * 1000000) + 1000) };

    if (giftEligible && !giftInCart) {
      return this.addItem(giftVarId, 1, giftProps)
        .then(response => {
          document.querySelector('.free-gift')
            .classList.add('animate__animated', 'animate__shakeY');
          return parsedState;
        });
    } else if (!giftEligible && giftInCart) {
      return this
        .updateQuantity((giftIndex + 1), 0, undefined, true)
        .then(() => { return parsedState });
    } else {
      return parsedState;
    }
  }

  checkFreeSamples(parsedState) {
    if (!window.freeSamplesData) {
      return parsedState;
    }

    let realTotalPrice = parsedState.total_price;
    const itemIndex0 = parsedState.items.findIndex(i => i.properties['_sampleId']);
    if (itemIndex0 === -1) {
      return parsedState;
    }

    realTotalPrice = realTotalPrice - parsedState.items[itemIndex0].final_price;

    if (
      !window.freeSamplesData ||
      realTotalPrice >= window.freeSamplesData.threshold
    ) {
      return parsedState;
    }

    return this.updateQuantity((itemIndex0 + 1), 0, undefined, true).then(() => { return parsedState });
  }

  checkAttachedGifts(parsedState) {
    if (
      !window.freeGiftData?.attachments?.length ||
      !parsedState?.items?.length
    ) {
      return;
    }

    const cartHandles = parsedState.items.map(x => x.handle);
    const giftsToAdd = [];
    const giftsToRemove = [];

    window.freeGiftData.attachments.forEach(attach => {
      const giftElegible = attach.attach_to.some(handle => cartHandles.includes(handle));
      const giftIndex = parsedState.items.findIndex(item => item.variant_id === attach.variant_id);

      if (giftElegible && giftIndex === -1) {
        giftsToAdd.push(attach.variant_id);
      }
      if (!giftElegible && giftIndex !== -1) {
        giftsToRemove.push(attach.variant_id);
      }
    });

    if (giftsToAdd.length) {
      const itemsArr = giftsToAdd.map(variant_id => {
        return {
          quantity: 1,
          id: variant_id,
          properties: { '_giftAttachId': Math.floor((Math.random() * 1000000) + 1000) }
        }
      });

      this.addItem(itemsArr)
        .then(parsedState => {
          document.querySelector('.free-gift')
            ?.classList.add('animate__animated', 'animate__shakeY');
          return parsedState;
        })
        .then(parsedState => {
          if (giftsToRemove.length) {
            this.removeItems(giftsToRemove, true);
          }
        });

    } else if (giftsToRemove.length) {
      this.removeItems(giftsToRemove, true);
    }
  }
}

customElements.define('cart-items', CartItems);

